import { css } from '@linaria/core';

export const colors = {
  disabled: '#9F9F9F',
};

export const rootClassname = css`
  margin-bottom: 14px;
  position: relative;
`;

export const inputContainerClassname = css`
  display: flex;
  border: solid 1px black;
`;

export const inputContainerFocused = css`
  border: 1px solid #006CFF;
  background-color: #F8F8F8;
`;

export const inputContainerDisabled = css`
  border-color: ${colors.disabled};
`;

export const inputClassname = css`
  font-size: 14px;
  padding: 14px;
  display: flex;
  flex: 3;
  border: 0;
  &:focus {
    background-color: transparent;
    caret-color: #006CFF;
  }
`;

export const leftElementContainer = css`
  display: flex;
  flex: 1;
`;

export const rightElementContainer = css`
  display: flex;
  flex: 1;
  max-width: 50px;
  background-color: #fff;
`;

export const inputWithError = css`
  border: 1px solid #E12147;
`;

export const inputWithWarning = css`
  border: 1px solid #FFAB00;
`;

export const inputDisabled = css`
  color: ${colors.disabled};
  cursor: not-allowed;
`;

export const errorClassname = css`
  padding: 0;
  margin: 0;
  margin-top: 7px;
  font-size: 10px;
  line-height: 10px;
  letter-spacing: 0.3px;
  color: #E12147;
`;

export const warningClassname = css`
  padding: 0;
  margin: 0;
  margin-top: 7px;
  font-size: 10px;
  line-height: 10px;
  letter-spacing: 0.3px;
  color: #FFAB00;
`;
